export const formStyle = {
  titleStyle: {
    textTransform: "capitalize"
  },
};



// WEBPACK FOOTER //
// ./src/containers/CRM/MessageTemplates/style.js